import {collection, DocumentData, onSnapshot, QueryDocumentSnapshot, Unsubscribe} from 'firebase/firestore';
import {db} from '../firebaseConfig';
import {IFirestoreProductionZone, IProductionZone} from './interfaces';
import {firestoreCollections} from './firestoreConstants';

const PRODUCTION_ZONE_FAB_MATCH = 'fab';

function mapProductionZoneDoc(
  productionZoneDoc: QueryDocumentSnapshot<DocumentData>
): IProductionZone | null {
  const productionZoneData = productionZoneDoc.data() as IFirestoreProductionZone;
  const productionZoneName = productionZoneData.productionZone;

  if (!productionZoneName.toLowerCase().includes(PRODUCTION_ZONE_FAB_MATCH)) {
    return null;
  }

  return {
    id: productionZoneDoc.id,
    name: productionZoneName,
    ref: productionZoneDoc.ref,
    fabCrews: productionZoneData.fabCrews ?? [],
  };
}

export function subscribeToProductionZones(
  onProductionZonesChange: (productionZones: IProductionZone[]) => void,
  onError: (error: Error) => void
): Unsubscribe {
  return onSnapshot(
    collection(db, firestoreCollections.productionZones),
    (snapshot) => {
      const productionZones = snapshot.docs
        .map(mapProductionZoneDoc)
        .filter((productionZone): productionZone is IProductionZone => productionZone !== null);

      onProductionZonesChange(productionZones);
    },
    onError
  );
}
